const dropin = require('./dropin')

module.exports = {
  dropin: dropin
};
